import { Box, Link, Text, Label } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Link,
  Text,
  Label,
  React
};